const runIntlPolyfill = () => {
  try {
    // eslint-disable-next-line no-underscore-dangle -- underscore
    Intl.__disableRegExpRestore();
  } catch (e) {
    // do nothing
  }
};

export default runIntlPolyfill;
